<template>
    <div class="sketch-content flex">
        <div class="page-content">
            <SketchBreadcrumb pageName="Achiziții cheltuieli"></SketchBreadcrumb>
            <div ref="parent_div" class="padding-box" @scroll="handleScroll">
                <div class="white-box">
                    <div class="data-group">
                        <div class="flex space-between align-center">
                            <div ref="scrollTo">
                                <h3 class="module-title">Completează cu atenție detaliile cu privire la Achiziții si cheltuieli</h3>
                                <p>Aceaste informații vor fi introduse in sistemul informatic MySmis.</p>
                            </div>
                            <div class="button-offer" @click="offersPanel = !offersPanel">
                                <b-icon-caret-down-fill v-if="!offersPanel"></b-icon-caret-down-fill>
                                <b-icon-caret-up-fill v-else></b-icon-caret-up-fill>
                                <div class="orange-button">Solicită o ofertă personalizată</div>
                            </div>
                        </div>
                        <div v-if="offersPanel" class="mt-5 mb-4">
                            <div v-if="offerMessage && offerMessage.length > 0" class="success-message">
                                <p>{{ offerMessage }}</p>
                            </div>

                            <div class="offers-list">
                                <div class="offer-block">
                                    <p>Utilaje CAT</p>
                                    <img src="@/assets/images/M3/M3Sketch/cat.png" alt="" class="offer-logo">
                                    <div class="offer-pic">
                                        <img src="@/assets/images/M3/M3Sketch/cat-pic.png" alt="">
                                    </div>
                                    <div class="button-offer-inside gray" @click="toggleModal('cat')">Solicită ofertă</div>
                                </div>
                                <div class="offer-block">
                                    <p>Echipamente IT & C</p>
                                    <img src="@/assets/images/M3/M3Sketch/nod.png" alt="" class="offer-logo">
                                    <div class="offer-pic">
                                        <img src="@/assets/images/M3/M3Sketch/nod-pic.png" alt="">
                                    </div>
                                    <div class="button-offer-inside gray" @click="toggleModal('nod')">Solicită ofertă</div>
                                </div>
                                <div class="offer-block">
                                    <p>Utilaje și echipamente</p>
                                    <img src="@/assets/images/M3/M3Sketch/ircat.png" alt="" class="offer-logo">
                                    <div class="offer-pic">
                                        <img src="@/assets/images/M3/M3Sketch/ircat-pic.png" alt="">
                                    </div>
                                    <div class="button-offer-inside gray" @click="toggleModal('ircat')">Solicită ofertă</div>
                                </div>
                                <div class="offer-block">
                                    <p>Energie regenerabilă</p>
                                    <img src="@/assets/images/M3/M3Sketch/goodwill.png" alt="" class="offer-logo">
                                    <div class="offer-pic">
                                        <img src="@/assets/images/M3/M3Sketch/goodwill-pic.png" alt="">
                                    </div>
                                    <div class="button-offer-inside gray" @click="toggleModal('goodwill')">Solicită ofertă</div>
                                </div>
                                <div class="offer-block">
                                    <p>Industria confecțiilor</p>
                                    <img src="@/assets/images/M3/M3Sketch/brorom.png" alt="" class="offer-logo">
                                    <div class="offer-pic">
                                        <img src="@/assets/images/M3/M3Sketch/brorom-pic.png" alt="">
                                    </div>
                                    <div class="button-offer-inside gray" @click="toggleModal('brorom')">Solicită ofertă</div>
                                </div>
                                <div class="offer-block">
                                    <p>Echipamente HORECA</p>
                                    <img src="@/assets/images/M3/M3Sketch/eurogastro.png" alt="" class="offer-logo">
                                    <div class="offer-pic">
                                        <img src="@/assets/images/M3/M3Sketch/eurogastro-pic.png" alt="">
                                    </div>
                                    <div class="button-offer-inside gray" @click="toggleModal('eurogastro')">Solicită ofertă</div>
                                </div>
                                <div class="offer-block">
                                    <p>Pompe căldură, ventilație</p>
                                    <img src="@/assets/images/M3/M3Sketch/trust.png" alt="" class="offer-logo">
                                    <div class="offer-pic">
                                        <img src="@/assets/images/M3/M3Sketch/trust-pic.png" alt="">
                                    </div>
                                    <div class="button-offer-inside gray" @click="toggleModal('trust')">Solicită ofertă</div>
                                </div>
                                <div class="offer-block">
                                    <p>Pompe căldură, panouri</p>
                                    <img src="@/assets/images/M3/M3Sketch/nedavi.png" alt="" class="offer-logo">
                                    <div class="offer-pic">
                                        <img src="@/assets/images/M3/M3Sketch/nedavi-pic.png" alt="">
                                    </div>
                                    <div class="button-offer-inside gray" @click="toggleModal('nedavi')">Solicită ofertă</div>
                                </div>
                                <div class="offer-block">
                                    <p>Mobilier sustenabil</p>
                                    <img src="@/assets/images/M3/M3Sketch/kinnarps.png" alt="" class="offer-logo">
                                    <div class="offer-pic">
                                        <img src="@/assets/images/M3/M3Sketch/kinnaps-pic.png" alt="">
                                    </div>
                                    <div class="button-offer-inside gray" @click="toggleModal('kinnarps')">Solicită ofertă</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <OfferModal :offerModal="offerModal" :currentOffer="currentOffer" @hideTempModal="offerModal = false" @offerSent="offerMessage = $event"></OfferModal>
                </div>
                <M3Warn v-if="allData && allData.m3_project && allData.m3_project.duplicate_sections && allData.m3_project.duplicate_sections.includes('acquisitions')" type="yellow" :text="'Această secțiune a fost duplicată din proiectul companiei ' + getCompanyName(allData.m3_project.duplicate_company_id)"></M3Warn>
                <AchizitiiCheltuieliContent :checkScroll="checkScroll" :allData="allData" :statistics="statistics" @addOrEditAchizitie="$emit('achizitiiChanged');" @completePage="completePage()"></AchizitiiCheltuieliContent>
            </div>
        </div>
        <b-icon-chevron-up class="back-to-top" @click="scrollToTop()"></b-icon-chevron-up>
    </div>
</template>

<script>
    import AchizitiiCheltuieliContent from '../components/achizitii-cheltuieli/AchizitiiCheltuieliContent'
    import OfferModal from '../components/achizitii-cheltuieli/OfferModal'
    import SketchBreadcrumb from '@/pages/Aplicatii/M3/M3Sketch/components/SketchBreadcrumb'
    import {BIconChevronUp, BIconCaretDownFill, BIconCaretUpFill} from 'bootstrap-vue'
    import M3Warn from "../components/M3Warn";

    export default {
        components: {
            AchizitiiCheltuieliContent,
            OfferModal,
            SketchBreadcrumb,
            BIconChevronUp,
            M3Warn,
            BIconCaretDownFill,
            BIconCaretUpFill
        },
        data() {
            return {
                checkScroll: false,
                offersPanel: false,
                offerModal: false,
                currentOffer: '',
                offerMessage: '',
            }
        },
        computed: {
            statistics() {
                return this.$store.getters['m3Sketch/indicators']
            },
            allData() {
                return this.$store.getters['m3Sketch/allData']
            },
            companies() {
                return this.$store.getters['m3Sketch/companies'];
            },
        },
        watch: {
            allData: {
                handler() {
                    this.completePage();
                },
                deep: true,
            }
        },
        mounted() {
            this.completePage();
        },
        methods: {
            toggleModal(companie) {
                this.offerModal = !this.offerModal
                this.currentOffer = companie
            },
            scrollToTop() {
                this.$refs.scrollTo.scrollIntoView({behavior: 'smooth', block: "center"});
            },

            getCompanyName(id){
                let name = '';
                if(this.companies !== null){
                    this.companies.forEach(company => {
                        if(Number(company.id) === Number(id))
                            name = company.name
                    })
                }

                return name;
            },

            completePage() {
                this.section = {
                    section: 'achizitii-cheltuieli'
                }
                let acquisitions = this.$store.getters['m3Sketch/allData']
                let completed = true
                if(acquisitions && acquisitions.m3_project && acquisitions.m3_project.spendings) {
                    acquisitions.m3_project.spendings.forEach(category => {
                        category.subcategories.forEach(subcategory => {
                            subcategory.acquisitions.forEach(spending => {
                                if(!spending.offer_1.id || !spending.offer_2.id || (spending.contribution_percentage !== 0 && !spending.env_contr.id)) {
                                    completed = false
                                }
                            })
                        })
                    })
                }
                if(completed)
                    this.$store.dispatch('pages/addPage', this.section)
                else
                    this.$store.dispatch('pages/removePage', this.section)
            },
            handleScroll(){
                if(this.$refs.parent_div.scrollTop > 0.15*this.$refs.parent_div.scrollHeight){
                    this.checkScroll = true;
                } else {
                    this.checkScroll = false;
                }
            }
        }
    }
</script>

<style scoped>
.data-group{
    margin: auto;
    width: 90%;
}
.sketch-content{
    position: relative;
}
.success-message{
    background: #49cda8;
    padding: 5px;
    text-align: center;
    margin: 20px auto;
    max-width: 500px;
}
.success-message p{
    text-align: center;
    max-width: 100% !important;
    color: #fff !important;
    font-size: 15px !important;
    font-weight: 600 !important;
}
.button-offer{
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    max-width: 250px;
    cursor: pointer;
}
.button-offer svg{
    color: #ffad17;
}
.orange-button{
    background: #ffad17;
    color: #fff;
    font-weight: 600;
    padding: 7px 10px;
    text-align: center;
    max-height: 40px;
    border-radius: 3px;
    font-size: 13px;
    width: 100%;
    max-width: 220px;
}
.offers-list{
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
    gap: 44px;
}
.offer-block{
    width: 100%;
    max-width: 265px;
    border: 1px solid #f0f0f0;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 290px;
    padding: 15px;
}
.offer-block .offer-logo{
    margin: 10px 0;
}
.offer-block .offer-pic{
    min-height: 165px;
    display: flex;
    align-items: center;
}
.offer-block p{
    font-size: 15px !important;
    font-weight: 700 !important;
    color: #515679 !important;
}
.button-offer-inside{
    margin-top: -5px;
    border: 10px solid #fff;
    padding: 7px 30px;
    text-align: center;
    font-size: 13px;
    color: #030304;
    border-radius: 4px;
    cursor: pointer;
}
.green-light{
    background: #d0e79a;
}
.green-dark{
    background: #85db92;
}
.yellow{
    background: #fecb15;
}
.red{
    background: #ff897a;
}
.orange{
    background: #f29400;
}
.pink{
    background: #f7e9e9;
}
.gray{
    background: #ecefee;
}
.page-content{
    position: relative;
}
.sketch-breadcrumb + .padding-box{
    height: 100%;

}
.space-between{
    justify-content: space-between;
}
.white-box{
    background: #fff;
    padding: 20px;
}
.module-title{
    margin: 0;
    color: #5b6276;
    font-size: 14px;
    margin-bottom: 5px;
}
.white-box{
    width: 100%;
}
.white-box p{
    color: #777e90;
    font-size: 12px;
    margin: 0;
    max-width: 960px;
}
.warning-sign{
    margin-left: 50px;
}
.back-to-top{
    cursor: pointer;
    position: absolute;
    bottom: -25px;
    right: 24px;
    color: #fff;
    z-index: 9;
    padding: 4px;
    border-radius: 4px;
    font-size: 25px;
    background: #8c6984;
}
@media (max-width: 1300px){
    .offers-list{
        flex-wrap: wrap;
        gap: 40px;
        justify-content: space-evenly;
    }
}
</style>
